import { render, staticRenderFns } from "./AtenaPaperSelectCard.vue?vue&type=template&id=c3c5c462&scoped=true"
import script from "./AtenaPaperSelectCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtenaPaperSelectCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AtenaPaperSelectCard.vue?vue&type=style&index=0&id=c3c5c462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c5c462",
  null
  
)

export default component.exports